import { createFileRoute, Link, useRouter } from "@tanstack/solid-router"
import ChevronRight from "lucide-solid/icons/chevron-right"
import LogOut from "lucide-solid/icons/log-out"
import { For, Match, Switch } from "solid-js"
import { Avatar, AvatarFallback, AvatarImage } from "~/components/ui/avatar"
import { Button, buttonVariants } from "~/components/ui/button"
import { Card, CardContent, CardFooter, CardHeader, CardTitle } from "~/components/ui/card"
import { Skeleton } from "~/components/ui/skeleton"
import { authClient } from "~/lib/auth/client"

export const Route = createFileRoute("/_authenticated/tablet/")({
  component: RouteComponent
})

function RouteComponent() {
  const organizations = authClient.useListOrganizations()

  const router = useRouter()

  return (
    <div class="flex min-h-screen items-center justify-center">
      <Card>
        <CardHeader>
          <CardTitle class="text-center">Select Server</CardTitle>
        </CardHeader>
        <CardContent class="space-y-2">
          <Switch>
            <Match when={organizations().isPending}>
              <Skeleton height={48} width={326} radius={8} />
              <Skeleton height={48} width={326} radius={8} />
              <Skeleton height={48} width={326} radius={8} />
            </Match>
            <Match when={!organizations().isPending}>
              <For each={organizations().data}>
                {(org) => (
                  <Link
                    to={"/tablet/$orgId/character"}
                    params={{ orgId: org.id }}
                    class={buttonVariants({ variant: "ghost", class: "h-12 w-80 justify-between" })}
                    onClick={() => {
                      authClient.organization.setActive({
                        organizationId: org.id
                      })
                    }}
                  >
                    <div class="flex items-center">
                      <Avatar class="mr-3 h-8 w-8">
                        <AvatarImage>{org.logo}</AvatarImage>
                        <AvatarFallback class="text-sm">{org.name.at(0)}</AvatarFallback>
                      </Avatar>
                      <div class="text-left">
                        <div class="font-medium">{org.name}</div>
                      </div>
                    </div>
                    <ChevronRight class="h-4 w-4" />
                  </Link>
                )}
              </For>
            </Match>
          </Switch>
        </CardContent>
        <CardFooter class="flex items-center justify-between px-8">
          <span class="text-sm">{organizations().data?.length} Servers</span>
          <Button
            variant="outline"
            size="sm"
            onClick={async () => {
              await authClient.signOut({
                fetchOptions: {
                  onSuccess: async () => {
                    //   queryClient.setQueryData(authQueryOptions().queryKey, null)
                    await router.invalidate()
                  }
                }
              })
            }}
          >
            <LogOut class="mr-2 h-4 w-4" />
            Sign Out
          </Button>
        </CardFooter>
      </Card>
    </div>
  )
}
